export const GLOBAL_STATE = 'Videos'

export const INTRO_VIDEOS = 'INTRO_VIDEOS' as const
